import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiModule, DirectivesModule, SharedComponentsModule } from '@ui';
import { MatBadgeModule } from '@angular/material/badge';
import { CoreModule } from '@core';
import { CollapsedTimerComponent } from '@app/components/layout/collapsed-timer/collapsed-timer.component';
import { RouterModule } from '@angular/router';
import { ModalsModule } from '@ui/lib/shared-modules/modals';

@NgModule({
	declarations: [CollapsedTimerComponent],
	imports: [
		CommonModule,
		DirectivesModule,
		UiModule,
		ModalsModule,
		MatBadgeModule,
		CoreModule,
		SharedComponentsModule,
		RouterModule,
		TranslateModule
	],
	exports: [CollapsedTimerComponent]
})
export class LayoutModule {}
